import { api } from "@/lib/api";

export interface BillingPlan { code: string; credits_per_month: number; months: number; price_cents: number; public: boolean }
export interface BillingPack { code: string; credits: number; price_cents: number }
export interface BillingStatus {
  plan_code: string | null;
  subscription_status: string | null;
  current_period_start: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  is_active: boolean;
  can_generate_ai: boolean;
  credits_balance: number;
  credits_per_month: number | null;
  discount_eligible: boolean;
  discount_reason_code?: string;
  plans: BillingPlan[];
  packs: BillingPack[];
}

export const getBillingStatus = () => api.get<BillingStatus>("/billing/status").then((r) => r.data);
export const getPublicPlans = () => api.get<Pick<BillingStatus, "plans" | "packs">>("/billing/plans").then((r) => r.data);
export const ACTIVE_SUBSCRIPTION_STATUSES = ["active", "trialing"];
export const subscriptionCheckout = (plan_code: string, origin_url: string) =>
  api.post<{ checkout_url: string }>("/billing/checkout-session", { plan_code, origin_url }).then((r) => r.data);
export const packCheckout = (product_code: string, origin_url: string) =>
  api.post<{ checkout_url: string }>("/billing/credit-pack-checkout", { product_code, origin_url }).then((r) => r.data);
export const cancelSubscription = () => api.post<BillingStatus>("/billing/cancel-subscription").then((r) => r.data);
export const customerPortal = (origin_url: string) => api.post<{ url: string }>("/billing/customer-portal", { origin_url }).then((r) => r.data);
export const isSubscriptionRequired = (err: any) => err?.response?.data?.detail?.code === "SUBSCRIPTION_REQUIRED";
export const deleteAccount = () => api.delete<{ deleted: boolean }>("/auth/me", { data: { confirm: true } }).then((r) => r.data);
export const isDeletionBlocked = (err: any) => err?.response?.data?.detail?.code === "SUBSCRIPTION_ACTIVE";
